import React, { useEffect, useMemo } from 'react'

import { useVideoThumbnail } from '../../../../shared/hooks/useVideoThumbnail'
import { FaPlay } from 'react-icons/fa'

import { HStack } from '@hivewatch/dark'

interface VideoThumbnailIProps {
  videoFile: File
}

export const VideoThumbnail = ({ videoFile }: VideoThumbnailIProps) => {
  const { thumbnail, videoRef } = useVideoThumbnail(videoFile)

  // Stable object URL for the hidden fallback <video>; revoked on change or
  // unmount so re-renders don't accumulate blob URLs for large files.
  const videoUrl = useMemo(() => URL.createObjectURL(videoFile), [videoFile])
  useEffect(() => () => URL.revokeObjectURL(videoUrl), [videoUrl])

  return (
    <HStack
      bgColor='#000000'
      borderRadius='md'
      height='50px'
      justifyContent='center'
      overflow='hidden'
      width='50px'
    >
      {thumbnail ? (
        <img
          alt='Video Thumbnail'
          src={thumbnail}
          style={{ width: '100%', height: 'auto' }}
        />
      ) : (
        <>
          <video ref={videoRef} src={videoUrl} style={{ display: 'none' }} />
          <FaPlay color='#fff' style={{ margin: 0 }} />
        </>
      )}
    </HStack>
  )
}
